// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"554":"8b84bf9a","558":"17a3cd97","726":"dee59758","787":"cda612ba","908":"591876f7"}[chunkId] + ".chunk.js";
};